<template>
  <div class="lang-switcher">
    <el-dropdown @command="handleCommand" placement="bottom-end">
      <span class="el-dropdown-link">
        {{ currentLang === 'zh-CN' ? '中文' : 'English' }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh-CN">中文</el-dropdown-item>
        <el-dropdown-item command="en-US">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
/**
 * 语言切换组件
 * 用于切换网站的显示语言
 */
export default {
  name: 'LangSwitcher',
  computed: {
    /**
     * 获取当前语言
     * @returns {string} 当前语言代码
     */
    currentLang() {
      return this.$i18n.locale;
    }
  },
  methods: {
    /**
     * 处理语言切换命令
     * @param {string} command - 语言代码
     */
    handleCommand(command) {
      if (this.currentLang !== command) {
        this.$i18n.locale = command;
        localStorage.setItem('lang', command);
        // 可选：刷新页面以确保所有组件都使用新语言
        location.reload();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lang-switcher {
  display: inline-block;
  cursor: pointer;

  .el-dropdown-link {
    color: #333;
    font-size: 14px;

    &:hover {
      color: #409EFF;
    }
  }
}

// 添加全局样式，提高下拉菜单的z-index
:global(.el-dropdown-menu) {
  z-index: 10000 !important;
}
</style>

<style>
/* 非scoped样式，确保能够覆盖element-ui的默认样式 */
.el-dropdown-menu {
  z-index: 10000 !important;
}
</style>
